import arrorRight from "../../assets/img/arrow-right.svg"
import userIcon from "../../assets/img/user_icon.svg"
import patient_file_management_icon from "../../assets/img/patient_file_management_icon.svg";
import from_our_desk_img from "../../assets/img/from_our_desk_img.jpg";
import feature_bg from "../../assets/img/feature_bg.svg";
import feature_1 from "../../assets/img/feature_1.svg";
import feature_2 from "../../assets/img/feature_2.svg";
import feature_3 from "../../assets/img/feature_3.svg";
import regular from "../../assets/img/regular.svg";
import silver from "../../assets/img/silver.svg";
import gold from "../../assets/img/gold.svg";
import plan_group from "../../assets/img/plan_group.jpg";
import discover_img from "../../assets/img/discover_img.jpg";
import hero from "../../assets/img/hero.jpg";
import tetimonial_block from "../../assets/img/tetimonial_block.png";
import quote from "../../assets/img/quote-icon.svg";
import drjane from "../../assets/img/dr.jane.jpg";

import { useEffect, useState } from 'react';
import Slider from 'react-slick';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { CallWithAuth } from "../../action/apiActions";
import { ADMIN_CMS_TESTIMONIALS } from "../../action/apiPath";
import { showToast } from "../../util/toastHelper";
import { GET_SUBSCRIPTION, INIT_SUBSCRIPTION } from "../../action/apiPath";

const SliderSettings = {
  dots: true,              // Show dots navigation
  infinite: true,          // Infinite loop
  speed: 500,              // Transition speed (ms)
  slidesToShow: 1,         // Number of slides to show at once
  slidesToScroll: 1,       // Number of slides to scroll at a time
  autoplay: true,          // Enable autoplay
  autoplaySpeed: 5000,     // Autoplay speed (ms)
  arrows: true,            // Show arrows for navigation
};


export const HomePage = () => {
  const accessToken = localStorage.getItem('accessToken');
  const subscription_id = localStorage.getItem("subscription_id");

  const [isLoading, setIsLoading] = useState(true);
  const [testimonialList, setTestimonialList] = useState([]);
  const [subscriptionDetail, setSubscriptionDetail] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    getTestimonialData();
    subscriptionList();
  }, []);

  const getTestimonialData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", ADMIN_CMS_TESTIMONIALS);
      if (response.res.status == 200) {
        setTestimonialList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const subscriptionList = async () => {
    try {
      const response = await CallWithAuth('GET', GET_SUBSCRIPTION)
      if (response.res.status == 200) {
        // toast.dismiss();
        // showToast("success", response.res.data.message);
        // toast.success(response.res.data.message, {
        //     autoClose: 2000,
        //     position: "bottom-right",
        // })
        setSubscriptionDetail(response.res.data.data)
      } else {
        // showToast("error", response.res.data.message);

        // toast.error(response.res.data.message, {
        //     autoClose: 2000,
        //     position: "bottom-right",
        // })
      }
    } catch (err) {
      showToast("error", err);
      // toast.error(err, {
      //     autoClose: 2000,
      //     position: "bottom-right",
      // })
    }
  }

  const getPlanDetails = (planName) => {
    let planClass = "";
    let planImage = null;
    let additionalContent = null;

    if (planName === "Regular Plan") {
      planClass = "regular_plan";
      planImage = regular; // Assuming you have imported the 'regular' image
    } else if (planName === "Gold Plan") {
      planClass = "gold_plan";
      planImage = gold; // Assuming you have imported the 'gold' image
    } else if (planName === "Silver Plan") {
      planClass = "silver_plan";
      planImage = silver; // Assuming you have imported the 'silver' image

      // Add additional content for Silver Plan
      additionalContent = <span class="tag">Most Popular</span>;
    }

    return { planClass, planImage, additionalContent };
  };

  // 30-second interval plan switcher
  useEffect(() => {
    if (!subscriptionDetail || subscriptionDetail.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === subscriptionDetail.length - 1 ? 0 : prev + 1
      );
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [subscriptionDetail]);

  const currentPlan = subscriptionDetail[currentIndex];

  return (
    <>

      <section class="site_hero">
        <div class="site_container">
          <div class="site_row">
            <div class="txt_colm">
              <div class="txt_block">
                <h1>Intelligent Insights for a Healthier Tomorrow.</h1>
                <p>Experience a revolutionary way to manage patient files and generate comprehensive reports.</p>
                <div class="btn_row">
                  {/* <Link to={'/#'} class="solid_cta cta_primary cta_with_icon"><span>Learn More</span> <img
                    src={arrorRight} alt="" /></Link> */}
                  {accessToken !== null ?
                    <Link to='create-account' className="outlined_cta cta_outline cta_with_icon"><img src={userIcon} alt="" /><span>Profile</span><img
                      src={arrorRight} alt="" />
                    </Link>
                    :
                    <Link to={'/signup'} class="outlined_cta cta_outline cta_with_icon"><span>Sign Up</span> <img
                      src={arrorRight} alt="" /></Link>}
                </div>
              </div>
            </div>
            <div class="img_colm">
              <div class="img_block">
                <img src={hero} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="from_our_desk">
        <div class="site_container">
          <div class="site_row">
            <div class="txt_colm">
              <div class="txt_block">
                <span class="tag">From our desk</span>
                <h2>Streamline Your Clinical Practice with Our Platform</h2>
                <p>Our web application offers a range of features to help <strong>clinicians manage their practice
                  efficiently and effectively</strong>. From <strong>account creation to patient file management and
                    report
                    generation</strong>, our platform simplifies the entire process.</p>
                <div class="card_list">
                  <div class="list_item">
                    <img src={userIcon} alt="" />
                    <h4>Account Creation</h4>
                    <p>Create secure accounts, select your role, and choose your theoretical framework.</p>
                  </div>
                  <div class="list_item">
                    <img src={patient_file_management_icon} alt="" />
                    <h4>Patient File Management</h4>
                    <p>Effortlessly organize patient files, upload documents, and generate templates for reports.</p>
                  </div>
                </div>
                <div class="btn_row">
                  {/* <Link to={'/#'} class="solid_cta cta_primary cta_with_icon"><span>Learn More</span> <img
                    src={arrorRight} alt="" /></Link> */}
                  {accessToken === null &&
                    <Link to={'/signup'} class="outlined_cta cta_outline cta_with_icon"><span>Sign Up</span> <img
                      src={arrorRight} alt="" /></Link>}
                </div>
              </div>
            </div>
            <div class="img_colm">
              <div class="img_block">
                <div class="block_inner">
                  <img src={from_our_desk_img} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="feature_block">
        <img src={feature_bg} alt="" class="f_bg" />
        <div class="site_container">
          <div class="heading_block">
            <span class="tag">Features</span>
            <h2>Streamline Your Clinical Practice with Our Powerful Features</h2>
            <p>Our web application offers a range of features designed to enhance your clinical practice. From role
              selection to theoretical framework options, we provide the tools you need to deliver personalized and
              effective care.</p>
          </div>
          <div class="site_row">
            <div class="colm">
              <div class="feature_item">
                <div class="top">
                  <div class="icon_block">
                    <img src={feature_1} alt="" />
                  </div>
                  <h3>Choose Your Role and Theoretical Framework</h3>
                  <p>Select your role as a psychologist or psychiatrist and choose from various theoretical frameworks,
                    including Psychodynamic Model, Bio Psychosocial Model, Cognitive Behavior Therapy (CBT).</p>
                </div>
                <div class="bottom">
                  {/* <a href=""><span>Learn More</span> <img src={arrorRight} alt="" /></a> */}
                </div>
              </div>
            </div>
            <div class="colm">
              <div class="feature_item">
                <div class="top">
                  <div class="icon_block">
                    <img src={feature_2} alt="" />
                  </div>
                  <h3>Efficient Diagnostic Tool Options</h3>
                  <p>Utilize our diagnostic tool options, such as DSM-5-TR or ICD-11, to accurately assess and diagnose your
                    patients.</p>
                </div>
                <div class="bottom">
                  {/* <a href=""><span>Learn More</span> <img src={arrorRight} alt="" /></a> */}
                </div>
              </div>
            </div>
            <div class="colm">
              <div class="feature_item">
                <div class="top">
                  <div class="icon_block">
                    <img src={feature_3} alt="" />
                  </div>
                  <h3>Simplify Patient File Management</h3>
                  <p>Create and organize patient files effortlessly, with the ability to upload medical records and past
                    reports for easy access and reference.</p>
                </div>
                <div class="bottom">
                  {/* <a href=""><span>Learn More</span> <img src={arrorRight} alt="" /></a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="testimonial_block">
        <div class="bg_layer">
          <img src={tetimonial_block} alt="" />
        </div>
        <div class="slider_layer">
          <div class="site_container">
            <div class="heading_block">
              <span class="tag">Testimonial</span>
              <h2>What the Clinicians say</h2>
            </div>
            <div class="testimonial_slider">
              <Slider {...SliderSettings}>

                {testimonialList && testimonialList.length > 0 ? (
                  testimonialList.map((item, index) => (
                    <div className="slide_item" key={index}>
                      <img src={quote} alt="" className="quote_icon" />
                      <p>{item?.quote}</p>

                      <div className="img_avatar">
                        <div className="img_block">
                          <img src={item?.author_image || drjane} alt={item?.author_name || "avatar"} />
                        </div>
                        <span className="title">{item?.author_name}</span>
                        <span className="desg">{item?.author_title}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-4 text-muted">
                    <p className="mb-0">No testimonials available at the moment.</p>
                  </div>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section class="pricing_plan_block">
        <div class="site_container">
          <div class="site_row">
            <div class="left_colm">
              <div class="heading_block">
                <span class="tag">Packages</span>
                <h2>Pricing Plans</h2>
                <p>Choose the subscription tier that suits your needs and budget.</p>
              </div>

              <ul class="plan_list">
                {subscriptionDetail?.map((items, i) => {
                  const { planImage, additionalContent } = getPlanDetails(items.name);
                  const isSubscribed = subscription_id === items.id; // Check if the subscription_id matches
                  return (
                    <li>
                      <div class="icon_block">
                        <img src={planImage} alt="" />
                      </div>
                      <div class="txts">
                        <p>{items?.name}</p>
                        <span>Access to <strong>{items?.number_of_reports} reports</strong> per month.</span>
                      </div>
                    </li>

                  )
                })}


                {/* <li>
                  <div class="icon_block">
                    <img src={silver} alt="" />
                  </div>
                  <div class="txts">
                    <p>Silver Plan</p>
                    <span>Access to <strong>30 reports</strong> per month.</span>
                  </div>
                </li>
                <li>
                  <div class="icon_block">
                    <img src={gold} alt="" />
                  </div>
                  <div class="txts">
                    <p>Gold Plan</p>
                    <span>Access to <strong>50 reports</strong> per month.</span>
                  </div>
                </li> */}
              </ul>
              <div class="btn_row">
                <Link to={'/subscription'} class="solid_cta cta_primary cta_with_icon"><span>View All Plans</span> <img
                  src={arrorRight} alt="" /></Link>
              </div>
            </div>
            <div class="plan_colm">
              <div class="bg_layer">
                <img src={plan_group} alt="" />
              </div>
              <div class="pkg_item">
                <div class="pkg_header">
                  <h5>{currentPlan?.name}</h5>
                  <div class="plan_price">
                    <h6><sup>$</sup>{currentPlan?.price}<sub>/mo</sub></h6>
                    <span>Limited Access</span>
                  </div>
                </div>
                <div class="pkg_body">
                  <span class="txt">Includes</span>
                  <div
                    dangerouslySetInnerHTML={{ __html: currentPlan?.description }}
                  />

                  <Link to={'/subscription'} class="get_started_btn"><span>View All Plans</span> <img src={arrorRight}
                    alt="" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="discover_block">
        <div class="bg_layer">
          <div class="img_block">
            <img src={discover_img} alt="" />
          </div>
        </div>
        <div class="txt_layer">
          <div class="site_container">
            <div class="site_row">
              <div class="left_colm">
                <div class="txt_block">
                  <span class="tag">Discover Now</span>
                  <h4>Transform Your Clinical Practice</h4>
                </div>
              </div>
              <div class="right_colm">
                <div class="txt_block">
                  <p>Discover a powerful platform that streamlines your workflow and enhances patient care.</p>
                  <div class="btn_row">
                    {/* <Link to={'/#'} class="solid_cta cta_primary cta_with_icon"><span>Learn More</span> <img
                      src={arrorRight} alt="" /></Link> */}
                    {accessToken === null &&
                      <Link to={'/signup'} class="outlined_cta cta_outline cta_with_icon"><span>Sign Up</span> <img
                        src={arrorRight} alt="" /></Link>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}